import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Caption({ children, light = false }) {
  return (
    <p className={`text-xs font-mono uppercase tracking-[0.25em] ${light ? "text-gold" : "text-terracotta"}`}>
      {children}
    </p>
  );
}
